import { Injectable } from '@angular/core';

import {
  Notification,
  NotificationProps,
} from '../../../../data/dietitian/domain/notification/notification';
import { NotificationCommands } from '../../../../data/dietitian/domain/notification/notification_commands';
import { ConversationCommands } from '../../../../data/message/domain/conversation/conversation_commands';
import { ConversationEventProvider } from '../../../../data/message/domain/events/conversation/conversation_event_provider';
import { DiaryCommands } from '../../../../data/tracker/domain/diary/diary_commands';

@Injectable()
export class MyTopbarFacade {
  constructor(
    private conversationCommands: ConversationCommands,
    private notificationCommands: NotificationCommands,
    private diaryCommands: DiaryCommands,
    private conversationEventProvider: ConversationEventProvider,
  ) {
    // nada
  }

  get conversationEvent$() {
    return this.conversationEventProvider.events$;
  }

  async countNewMessages(
    patientUserId: string,
    dietitianId: string,
  ): Promise<number> {
    return this.conversationCommands.countMessagesToPatient(
      patientUserId,
      dietitianId,
    );
  }

  async getPatientNotifications(
    patientId: string | undefined,
  ): Promise<Notification[]> {
    if (patientId) {
      return this.notificationCommands.findPatientNotifications(patientId);
    }
    return [];
  }

  async markNotificationAsRead(
    patientId: string,
    notification: Notification,
  ): Promise<Notification> {
    const notificationProps = {
      ...notification.props,
      readAt: new Date(),
    } as NotificationProps;

    return this.notificationCommands.updatePatient(
      patientId,
      notification?.notificationId?.id?.toString(),
      notificationProps,
    );
  }

  async getPatientDiary(patientId: string, diaryId: string) {
    return this.diaryCommands.getPatientDiary(patientId, diaryId);
  }
}
